"use client"

// src/components/airy.ts
var Airy = {
  baseStyle: {
    userSelect: "none",
    width: "fit-content",
    _disabled: {
      cursor: "not-allowed",
      opacity: 0.4
    },
    _readOnly: {
      cursor: "default"
    }
  },
  variants: {},
  sizes: {},
  defaultProps: {}
};

export {
  Airy
};
//# sourceMappingURL=chunk-ANTTICWY.mjs.map